module.exports = require('./helpers/bundle-url').getBundleURL('jl8RY') + "logo-dark.eefe0b7f.svg";